<template>
  <div>
    <div class="bg-white w-full px-4 pt-5 pb-8 shadow-md mb-2">
      <div class="mb-3 md:flex items-center justify-between">
        <div class="sm:w-2/5">
          <el-tooltip
            :content="wrapTooltipContent(course.title)"
            effect="dark"
            :raw-content="true"
            placement="top-start"
          >
            <h3 class="font-bold text-2xl text-untitled-gray-700 line-clamp-2">
              <span
                class="el-only-child__content el-tooltip__trigger el-tooltip__trigger"
              >
                {{ course.title }}</span
              >
            </h3>
          </el-tooltip>
        </div>
        <!-- <div class="flex flex-row gap-2 justify-end items-center">
					<div
						class="flex gap-1 peer-hover:hidden beer-hover:hidden items-center text-untitled-gray-600"
					>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							aria-hidden="true"
							class="h-4 w-4"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
							></path>
						</svg>
						<p class="text-xs">2 videos</p>
					</div>
					<div class="flex gap-1 peer-hover:hidden items-center text-untitled-gray-600">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							aria-hidden="true"
							class="h-4 w-4"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
							></path>
						</svg>
						<p class="text-xs">02/23/2023</p>
					</div>
					<div class="flex gap-1 peer-hover:hidden items-center text-untitled-gray-600">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke-width="2"
							stroke="currentColor"
							aria-hidden="true"
							class="h-4 w-4"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
							></path>
						</svg>
						<p class="text-xs">0/2 videos completed</p>
					</div>
				</div> -->
      </div>
      <div class="md:flex items-center gap-3">
        <div class="md:w-full">
          <span @click="handleOpenScormCourse(course)"
            ><div class="relative cursor-pointer">
              <img
                class="object-scale-down aspect-video w-full lg:w-[60%] is-loaded"
                lazy="loaded"
                :src="course.preview_image"
              />
              <div
                class="absolute w-full lg:w-[60%] bottom-0 h-full object-center inset-0 place-items-center bg-gradient-to-t from-black opacity-50 text-white text-xs text-center leading-4"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="mt-[18%] object-center place-items-center inset-0 mx-auto w-12 h-12"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                  ></path>
                </svg>
              </div></div
          ></span>
          <p class="block mt-4">
            <span
              :class="{
                'inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20':
                  course.scormStatus === 'completed',
                'inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20':
                  course.scormStatus === 'not-started',
                'inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10':
                  course.scormStatus === 'incomplete',
              }"
            >
              {{ progressLabel }}
            </span>
          </p>
        </div>
        <div class="w-full">
          <div class="container mx-auto">
            <div class="w-full gap-2 mx-auto mb-5 md:mt-5">
              <div class="flex justify-end gap-1 flex-col md:flex-row">
                <!-- <a
                  href="javascript:"
                  class="flex w-full justify-center rounded-md border border-transparent bg-untitled-gray-200 py-2 px-4 font-medium text-untitled-gray-800 shadow-sm hover:bg-untitled-gray-300 focus:outline-none focus:ring-2 focus:ring-untitled-gray-500 focus:ring-offset-2 text-xs"
                  style="visibility: visible"
                  ><small>Assign Course</small></a
                > -->
                <div class="el-overlay" style="z-index: 2196; display: none">
                  <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="el-id-8848-439"
                    aria-describedby="el-id-8848-440"
                    class="el-overlay-dialog"
                  ></div>
                </div>
                <div class="el-overlay" style="z-index: 2197; display: none">
                  <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="el-id-8848-441"
                    aria-describedby="el-id-8848-442"
                    class="el-overlay-dialog"
                  ></div>
                </div>
                <button
                  @click="handleOpenScormCourse(course)"
                  class="flex w-full justify-center rounded-md border border-transparent bg-untitled-gray-200 py-2 px-4 font-medium text-untitled-gray-800 shadow-sm hover:bg-untitled-gray-300 focus:outline-none focus:ring-2 focus:ring-untitled-gray-500 focus:ring-offset-2 text-xs"
                >
                  <small>
                    {{ learningLabel }}
                  </small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";
import { ElTooltip } from "element-plus";
import { wrapTooltipContent } from "@/composable/wrapTooltipContent";

const router = useRouter();

const props = defineProps({
  course: {
    type: Object,
    required: true,
  },
});

const course = computed(() => props.course);

const handleOpenScormCourse = (course) => {
  router.push({
    name: "ScormCourseWatch",
    params: {
      id: course.provider_id,
    },
  });
};

const progressLabel = computed(() => {
  if (course.value.scormStatus === "incomplete") {
    return "In Progress";
  }
  if (course.value.scormStatus === "completed") {
    return "Completed";
  }

  return "Not Started";
});

const learningLabel = computed(() => {
  if (
    course.value.scormStatus === "not-started" ||
    progressLabel.value === "Not Started" ||
    course.value.scormStatus === "unknown"
  ) {
    return "Start Learning";
  }

  if (course.value.scormStatus === "completed") {
    return "Retake Course";
  }

  return "Continue Learning";
});
</script>
